import React from 'react';
import { Card, Badge, Button } from './Shared';
import SafeIcon from '../common/SafeIcon';
import { exceptions } from '../data/mockData';

const ExceptionsCenter = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-end">
        <div>
          <h1 className="text-2xl font-bold text-slate-100 flex items-center gap-2">
            <SafeIcon name="AlertTriangle" className="text-alert-500" />
            Exception Center
          </h1>
          <p className="text-slate-400 mt-1">Critical issues requiring immediate intervention.</p>
        </div>
        <Badge type="danger" className="text-sm px-3 py-1 animate-pulse">3 Active Alerts</Badge>
      </div>

      <div className="grid gap-4">
        {exceptions.map((exc) => (
          <Card key={exc.id} className="border-l-4 border-l-alert-500 flex flex-col md:flex-row gap-6 items-start md:items-center">
            <div className="flex-grow space-y-2">
              <div className="flex items-center gap-3">
                <Badge type={exc.severity === 'Critical' ? 'danger' : 'warning'}>{exc.severity}</Badge>
                <span className="text-xs font-mono text-slate-500">REF: {exc.id}</span>
                <span className="text-xs text-slate-500 flex items-center gap-1"><SafeIcon name="Clock" className="text-[10px]"/> {exc.time}</span>
              </div>
              <h3 className="text-lg font-medium text-slate-200">{exc.type} <span className="text-slate-500 mx-2">|</span> {exc.shipmentId}</h3>
              <p className="text-sm text-slate-400">{exc.description}</p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto shrink-0">
               {exc.type === 'Documentation' ? (
                 <>
                  <Button variant="secondary" icon="UploadCloud">Upload Doc</Button>
                  <Button variant="primary" icon="PhoneCall">Contact Broker</Button>
                 </>
               ) : (
                 <>
                  <Button variant="secondary" icon="Map">View Impact</Button>
                  <Button variant="danger" icon="RefreshCw">Initiate Reroute</Button>
                 </>
               )}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ExceptionsCenter;